/* eslint-disable react-hooks/exhaustive-deps */
import useInterfaceConfig from "@hooks/useInterfaceConfig";
import CotizadorGeneric from "./CotizadorGeneric";

const CotizadorWrapper = () => {
  const interfaceConfig = useInterfaceConfig();

  if (interfaceConfig.cotizador_simple?.type === "simple") {
    return <CotizadorGeneric />;
  } else {
    return null;
  }
};

export default CotizadorWrapper;
